import React from "react";
import "./ECLInput.css";
import { ECLNumber } from "../../../../index";

export default function ECLInteger(props) {
   return props.unit ? (
      <div>
         <label htmlFor={props.id}>
            {props.name}{" "}
            {props.required && <span className="required-input">*</span>}
         </label>
         <div className="ecl-input-container">
            <ECLNumber
               id={props.id}
               key={props.id}
               min={props.min}
               max={props.max}
               placeholder={props.placeholder}
               labelWidth={props.labelWidth}
               required={props.required}
            />
            <p
               className="unit-of-measurement"
               style={props.labelWidth && { width: props.labelWidth }}
            >
               {props.unit}
            </p>
         </div>
      </div>
   ) : (
      <ECLNumber {...props} />
   );
}
